import React, { FunctionComponent } from 'react';
import { Typography } from '@material-ui/core';
import transferModalContentStyles from './transferModalContentStyles';
import Translation from '../../../../common/components/translation/Translation';

export interface ITransferModalContentProps {
  question: string;
}

const TransferModalContent: FunctionComponent<ITransferModalContentProps> = ({ question }) => {
  const styles = transferModalContentStyles();

  return (
    <Typography className={styles.question}>
      <Translation id={question} />
    </Typography>
  );
};

export default TransferModalContent;
